export default __webpack_public_path__ + "static/media/FCU.d8179624.png";